export const PHASE_MODAL_SLICE_DEFAULT_VALUES = {
  isEdit: false,
  openPhaseModal: false,
  updatedPhase: null,
};

export const PHASE_ITEM_MODAL_SLICE_DEFAULT_VALUES = {
  openPhaseItemModal: false,
  updatedPhaseItem: null,
};

export const CREATE_CHECKLIST_MODAL_SLICE_DEFAULT_VALUES = {
  openCreateChecklistModal: false,
  fromGantt: false,
};

export const CREATE_PHASE_ITEM_SLICE_DEFAULT_VALUES = {
  openCreatePhaseItemModal: null,
  ganttItemId: null,
};

export const EDIT_CHECKLIST_MODAL_DEFAULT_VALUES = {
  openEditChecklistModal: null,
  fromGantt: false,
};

export const SAVE_TEMPLATE_MODAL_SLICE_DEFAULT_VALUES = {
  openSaveTemplateModal: false,
};
